export function deepClone<T>(obj: T): T {
    if (typeof obj === 'undefined') {
        return undefined as any
    }

    if (obj === null) {
        return null as any
    }

    if (Array.isArray(obj)) {
        return (obj as T[]).map((obj: T, _: number, __: T[]) => deepClone(obj)) as any
    }

    if (typeof obj !== 'object') {
        return obj
    }

    return Object.entries(obj).reduce(function (newObj, [key, value]) {
        newObj[key] = deepClone(value)
        return newObj
    }, {} as {[key: string]: any}) as any
}
